module.exports = __webpack_public_path__ + "img/logo1 (11).ab4a0125.jpg";